import { useState, useEffect } from 'react';

/**
 * Custom hook to load workflow from localStorage based on listing type, category, and subcategory
 * Returns the workflow object if found, null otherwise
 */
export const useCustomWorkflow = (listingType, category, subcategory) => {
  const [workflow, setWorkflow] = useState(null);

  useEffect(() => {
    if (!listingType || !category) {
      setWorkflow(null);
      return;
    }

    try {
      const stored = localStorage.getItem('customSteps');
      if (!stored) {
        setWorkflow(null);
        return;
      }

      const workflows = JSON.parse(stored);
      
      // Try to find workflow with exact match (including subcategory)
      let key = subcategory 
        ? `${listingType}___${category}___${subcategory}`
        : `${listingType}___${category}___`;
      
      let foundWorkflow = workflows[key];
      
      // If not found with subcategory, try without subcategory
      if (!foundWorkflow && subcategory) {
        key = `${listingType}___${category}___`;
        foundWorkflow = workflows[key];
      }
      
      // If still not found, try with just category (backwards compatibility)
      if (!foundWorkflow) {
        key = `${listingType}___${category}`;
        foundWorkflow = workflows[key];
      }
      
      if (foundWorkflow) {
        // Normalize workflow structure
        const normalizedWorkflow = {
          listingType: foundWorkflow.listingType || listingType,
          category: foundWorkflow.category || category,
          subcategory: foundWorkflow.subcategory || subcategory || '',
          steps: foundWorkflow.steps || (Array.isArray(foundWorkflow) ? foundWorkflow : [])
        };
        
        setWorkflow(normalizedWorkflow);
      } else {
        setWorkflow(null);
      }
    } catch (error) {
      console.error('Error loading custom workflow:', error);
      setWorkflow(null);
    }
  }, [listingType, category, subcategory]);

  return workflow;
};
